module.exports = __webpack_public_path__ + "media/images/about_top_header-b7ba40e2bfd7a5697d6cafd8993aff73.svg";